import { View, ViewOff2 } from '@shared/icons';
import type { PasswordVisibilityToggleProps } from '../../../types';

function PasswordVisibilityToggle({ isPasswordVisible, togglePasswordVisible, disabled }: PasswordVisibilityToggleProps) {
  const ariaLabel = isPasswordVisible ? 'Hide password' : 'Show password';

  const classes = `absolute right-0 top-1/2 -translate-y-1/2 ${!disabled && 'cursor-pointer'}`;

  if (isPasswordVisible === undefined || togglePasswordVisible === undefined) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={togglePasswordVisible}
      disabled={disabled}
      aria-label={ariaLabel}
      className={classes}
      data-track-name="Visibility"
      data-track-visible={isPasswordVisible ? 'Show' : 'Hide'}
    >
      {isPasswordVisible ? <View aria-hidden="true" size="medium" /> : <ViewOff2 aria-hidden="true" size="medium" />}
    </button>
  );
}

export { PasswordVisibilityToggle };
